import { motion } from "framer-motion";
import { Users, ShieldCheck, AlertTriangle, XCircle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const CARDS = [
  { key: "employees", tk: "employees", icon: Users, color: "text-slate-700", ring: "bg-slate-100", accent: "border-slate-200" },
  { key: "docs_valid", tk: "docsValid", icon: ShieldCheck, color: "text-emerald-600", ring: "bg-emerald-50", accent: "border-emerald-200" },
  { key: "docs_expiring", tk: "docsExpiring", icon: AlertTriangle, color: "text-amber-600", ring: "bg-amber-50", accent: "border-amber-200" },
  { key: "docs_expired", tk: "docsExpired", icon: XCircle, color: "text-red-600", ring: "bg-red-50", accent: "border-red-200" },
];

export const StatsCards = ({ stats }) => {
  const { t } = useLang();
  return (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
    {CARDS.map((c, i) => {
      const Icon = c.icon;
      return (
        <motion.div
          key={c.key}
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.08, duration: 0.4 }}
          data-testid={`stats-card-${c.key}`}
          className={`rounded-2xl border ${c.accent} bg-white shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 p-5`}
        >
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{t(`dash.stats.${c.tk}`)}</p>
              <p className={`mt-2 text-3xl font-extrabold font-heading ${c.color} font-mono-nums`}>
                {stats ? stats[c.key] ?? 0 : "—"}
              </p>
            </div>
            <div className={`h-12 w-12 rounded-xl ${c.ring} flex items-center justify-center`}>
              <Icon className={`h-6 w-6 ${c.color}`} strokeWidth={2.2} />
            </div>
          </div>
        </motion.div>
      );
    })}
  </div>
  );
};
